document.querySelectorAll('.select-country').forEach(function(selectCountry) {
    selectCountry.addEventListener('click', function(e) {
        if (!e.target.classList.contains('custom-option')) {
            this.classList.toggle('open');
        }
    });
    selectCountry.querySelectorAll('.custom-option').forEach(function(option) {
        option.addEventListener('click', function(e) {
            e.stopPropagation();
            if (!this.classList.contains('selected')) {
                const parent = this.parentNode;
                const prev = parent.querySelector('.custom-option.selected');
                if (prev) prev.classList.remove('selected');
                this.classList.add('selected');
                this.closest('.select').querySelector('.select__trigger span').textContent = this.textContent;
            }
            selectCountry.classList.remove('open');
        });
    });
});
